<template>
  <div class="hedan-big-prize-wrapper">
    <div class="big-prize-list" ref="list" :class="{ 'active': addTransition }"></div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    gc: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      index: 0,
      addTransition: false
    }
  },
  mounted() {
    this.getAnimateProperty()
    this.initialBarrage()
  },
  watch: {
    list(n) {
      if (n.length > 0) {
        clearInterval(this._barrage_timer_)
        this._barrage_timer_ = null
        this.$refs['list'].innerHTML = ''
        this.initialBarrage()
      }
    }
  },
  methods: {
    initialBarrage() {
      if (this.list.length >= 3) {
        for (let i = 0; i < 3; i++) {
          this.$refs['list'].appendChild(this.createBarrageItem(i))
          this.index++
        }
        this.initialScroll()
      } else if (this.list.length > 0) {
        this.$refs['list'].appendChild(this.createBarrageItem(0))
      }
    },
    initialScroll() {
      this._barrage_timer_ = setInterval(() => {
        if (this.index >= this.list.length) {
          this.index = 0
        }
        this.$refs['list'].appendChild(this.createBarrageItem(this.index))
        this.index++
        this.addTransition = !this.addTransition
        setTimeout(() => {
          this.$refs['list'].style[this._transform] = 'translateY(-34px)'
        }, 300)
        setTimeout(() => {
          this.addTransition = !this.addTransition
        }, 700)
        setTimeout(() => {
          this.$refs['list'].style[this._transform] = 'translateY(0)'
          if (document.querySelectorAll('.barrage-item').length > 3) {
            this.$refs['list'].removeChild(document.querySelector('.barrage-item'))
          }
        }, 750)
      }, 3500)
    },
    createBarrageItem(index) {
      var dom = document.createElement('div')
      dom.className = 'barrage-item'
      var arr = ['传说', '史诗', '稀有', '普通']
      dom.innerHTML = `<p class="desc" style="color: ${this.gc.main_color}">恭喜</p>
      <p class="nickname" style="color: ${this.gc.main_color}">${this.list[index].username}</p>
      <p class="desc" style="color: ${this.gc.main_color}">获得</p>
      <div class="prize-box">
        <div class="prize color-${this.list[index].rarity}">
          <p class="tag">${arr[this.list[index].rarity - 1]}</p>
          <p class="prize-name" style="color: ${this.gc.main_color}">${this.list[index].itemname}</p>
        </div>
      </div>`
      return dom
    },
    getAnimateProperty() {
      var el = document.createElement('p')
      var transforms = ['transform', 'oTransform', 'msTransform', 'mozTransform', 'webkitTransform']
      for (let key in transforms) {
        if (transforms[key] in el.style) {
          this._transform = transforms[key]
          break;
        }
      }
    }
  }
}
</script>

<style lang='less'>
.hedan-big-prize-wrapper {
  width: 100%;
  max-height: 108px;
  padding: 12px 0;
  overflow: hidden;
  transform: translate3d(0, 0, 0);

  .big-prize-list {
    width: 100%;
    height: 100%;
    padding: 0;

    &.active {
      transition: transform .35s linear;
    }

    .barrage-item {
      width: 100%;
      height: 16px;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      // padding: 4px 0;

      .prize-box {
        width: 0;
        flex: 1;
        height: 16px;
        margin-left: 8px;

        .prize {
          width: auto;
          max-width: 100%;
          height: 16px;
          display: flex;
          align-items: center;
          padding-right: 5px;
          padding-left: 28px;
          position: relative;
          border-radius: 2px;
          float: left;

          .tag {
            width: 48px;
            height: 200%;
            line-height: 28px;
            text-align: center;
            font-size: 18px;
            color: #fff;
            font-weight: 500;
            position: absolute;
            top: 0px;
            left: 0px;
            transform-origin: top left;
            transform: scale(0.5);
          }

          .prize-name {
            height: 14px;
            line-height: 14px;
            font-size: 11px;
            color: #d2d3d7;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &.color-1 {
            border: 1px solid #fe7f00;

            .tag {
              background-color: #fe7f00;
            }
          }

          &.color-2 {
            border: 1px solid #7a60ff;

            .tag {
              background-color: #7a60ff;
            }
          }

          &.color-3 {
            border: 1px solid #00b1fb;

            .tag {
              background-color: #00b1fb;
            }
          }

          &.color-4 {
            border: 1px solid #46cc76;

            .tag {
              background-color: #46cc76;
            }
          }
        }
      }

      .desc {
        font-size: 12px;
        color: #8c9196;
      }

      .nickname {
        width: 84px;
        font-size: 12px;
        color: #8c9196;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 8px;
      }
    }


    .no-data {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #87888c;
    }
  }
}
</style>
